<template>
  <div>
    <b-field>
      {{ $t('attractor_info') }}
    </b-field>
  </div>
</template>